import { styled } from '@zoopla-eng/zds-components/themes';
import {
    ADBRIDG_CLASS,
    AdvertSlotDfp,
    AD_UNIT_ROOTS,
    AD_UNIT_SECTION
} from '@zoopla/adverts/dfp';
import { Box } from '@zoopla-eng/zds-components/box';

const Sticky = styled('div', {
    position: 'sticky',
    top: 0,
    width: '100%'
});

export const NewHomesAdverts = () => {
    return (
        <>
            <Box pt="$S200">
                <AdvertSlotDfp
                    position={0}
                    showOnly={['>', 960]}
                    sizes={[[300, 16], 'fluid']}
                    adUnitCode={[
                        AD_UNIT_ROOTS.TEXT_LINK,
                        AD_UNIT_SECTION.NEW_HOMES,
                        '/House-Prices'
                    ]}
                    adbridgClass={ADBRIDG_CLASS.TEXT_LINK}
                />
            </Box>
            <AdvertSlotDfp
                position={1}
                showOnly={['>', 960]}
                sizes={[[300, 250]]}
                adUnitCode={[
                    AD_UNIT_ROOTS.MPU,
                    AD_UNIT_SECTION.NEW_HOMES,
                    '/House-Prices'
                ]}
                adbridgClass={ADBRIDG_CLASS.MPU}
            />
            <Sticky>
                <AdvertSlotDfp
                    position={2}
                    showOnly={['>', 960]}
                    sizes={[[300, 600]]}
                    adUnitCode={[
                        AD_UNIT_ROOTS.SKY_SCRAPER,
                        AD_UNIT_SECTION.NEW_HOMES,
                        '/House-Prices'
                    ]}
                    adbridgClass={ADBRIDG_CLASS.SKYSCRAPER}
                />
            </Sticky>
        </>
    );
};
